import UcMeterInvoices from './UcMeterInvoices.yaml?component';

export { UcMeterInvoices };
